import { render, staticRenderFns } from "./IndexYear2017.vue?vue&type=template&id=5054e9e4&scoped=true&"
import script from "./IndexYear2017.vue?vue&type=script&lang=js&"
export * from "./IndexYear2017.vue?vue&type=script&lang=js&"
import style0 from "./IndexYear2017.vue?vue&type=style&index=0&id=5054e9e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054e9e4",
  null
  
)

export default component.exports